// React imports
import React from 'react';

// Third-party imports
import clsx from 'clsx';

// UI Components
import Checkbox from 'components/UI/V3/Forms/Checkbox';

// Styles
import styles from './ServiceCategorySelector.module.scss';

interface ServiceCategorySelectorProps {
    label: string;
    selectedCount: number;
    emptyMessage: string;
    className?: string;
    onClick: () => void;
    disabled?: boolean;
}

const ServiceCategorySelectorComponent: React.FC<ServiceCategorySelectorProps> = ({
    label,
    selectedCount,
    emptyMessage,
    className,
    onClick,
    disabled = false
}) => {
    const isDisabled = selectedCount === 0;

    return (
        <div
            className={clsx(styles.serviceCategory, { [styles.disabled]: isDisabled }, className)}
            onClick={onClick}
        >
            <div className={clsx(styles.checkboxWrapper, { [styles.disabled]: disabled })}>
                <Checkbox
                    label={label}
                    checked={selectedCount > 0}
                />
            </div>
            {selectedCount > 0 ? <p>{selectedCount} selected</p> : <p>{emptyMessage}</p>}
        </div>
    );
};

export const ServiceCategorySelector = React.memo(ServiceCategorySelectorComponent);
